import { dispositionsQuery } from "@common/api/quoting/disposition"
import { createFileRoute, Outlet } from "@tanstack/react-router"
import { PageContent, PageTitle } from "@/components/page/page-content"
import { requirePermission } from "@/lib/require-permission"
import { DispositionList } from "./-components/disposition-list"

export const Route = createFileRoute("/_layout/settings/_panel/quoting/status")(
  {
    staticData: {
      breadcrumb: [
        { label: "Quoting - Status", href: "/settings/quoting/status" },
      ],
    },
    beforeLoad: ({ context: { queryClient } }) =>
      requirePermission(
        queryClient,
        "quote_disposition:read",
        "/settings/workspace/general",
      ),
    loader: ({ context: { queryClient } }) =>
      queryClient.ensureQueryData(dispositionsQuery()),
    component: StatusPage,
  },
)

function StatusPage(): React.ReactElement {
  return (
    <PageContent>
      <PageTitle
        title="Status"
        description="The order a quote moves through. The internal review stage can be renamed or turned off; with it off, a draft goes straight to the customer."
      />
      <DispositionList />
      <Outlet />
    </PageContent>
  )
}
